import { basicEnum } from "./base";

export const RadiusAccountTypeEnum = basicEnum([
    {
        label: "STANDALONE",
        value: "standalone",
    },
    {
        label: "SUBSCRIPTION",
        value: "subscription",
    },
]);

export namespace RadiusAccountTypeEnum {
    export type Labels = (typeof RadiusAccountTypeEnum)["labels"][number];
    export type Values = (typeof RadiusAccountTypeEnum)["values"][number];
}
